<template>
  <v-row dense>
    <v-col cols="12" lg="6">
      <v-card outlined class="mb-6">
        <v-card-title class="text-subtitle-1 font-weight-medium">
          {{ $t("language_settings") }}
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-4">
          <language-settings-section
            v-model="localAlphabet"
            :settings="settings"
            :restaurant-id="restaurantId"
          />
        </v-card-text>
      </v-card>

      <v-card outlined class="mb-6">
        <v-card-title class="text-subtitle-1 font-weight-medium">
          {{ $t("options") }}
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-4">
          <v-row dense align="center">
            <v-col cols="12" md="4">
              <autocomplete
                :items="currencies"
                item-value="val"
                v-model="settings.price"
                :label="$t('select_currency')"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card outlined class="mb-6">
        <v-card-title class="text-subtitle-1 font-weight-medium">
          {{ $t("order_dead_line") }}
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-4">
          <v-row dense>
            <v-col cols="12" md="6">
              <v-switch
                v-model="settings.no_time_limit"
                inset
                :label="$t('settings_no_time_limit')"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-switch
                v-model="settings.confirm_delivery"
                inset
                :label="$t('automatic_delivery_no_confirm')"
              />
            </v-col>
            <v-col cols="12" md="4">
              <text-field
                v-model="settings.timer"
                :label="$t('next_delivery_time_sec')"
                :suffix="$t('seconds')"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" lg="6">
      <v-card outlined class="mb-6">
        <v-card-title class="text-subtitle-1 font-weight-medium">
          {{ $t("design_web") }}
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-4">
          <web-design-section
            :settings="settings"
            :restaurant-id="restaurantId"
            @select-image="$emit('select-image', $event)"
            @remove-image="$emit('remove-image', $event)"
          />
        </v-card-text>
      </v-card>

      <v-card outlined class="mb-6">
        <v-card-title class="text-subtitle-1 font-weight-medium">
          {{ $t("mobile_app_design") }}
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-4">
          <mobile-app-design-section
            :settings="settings"
            :restaurant-id="restaurantId"
            @select-image="$emit('select-image', $event)"
            @remove-image="$emit('remove-image', $event)"
          />
        </v-card-text>
      </v-card>

      <v-card outlined class="mb-6">
        <v-card-title class="text-subtitle-1 font-weight-medium">
          {{ $t("links") }}
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-4">
          <links-section :settings="settings" />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import LanguageSettingsSection from "@/components/restaurants/settings/general/LanguageSettingsSection.vue";
import WebDesignSection from "@/components/restaurants/settings/general/WebDesignSection.vue";
import MobileAppDesignSection from "@/components/restaurants/settings/general/MobileAppDesignSection.vue";
import LinksSection from "@/components/restaurants/settings/general/LinksSection.vue";

export default {
  name: "GeneralSettingsTab",
  model: {
    prop: "alphabet",
    event: "input",
  },
  components: {
    LanguageSettingsSection,
    WebDesignSection,
    MobileAppDesignSection,
    LinksSection,
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
    alphabet: {
      type: String,
      required: true,
    },
    restaurantId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      localAlphabet: this.alphabet,
      currencies: [
        { text: "KM", val: "KM" },
        { text: "EUR", val: "EUR" },
        { text: "DIN", val: "DIN" },
      ],
    };
  },
  watch: {
    alphabet(newValue) {
      this.localAlphabet = newValue;
    },
    localAlphabet(newValue) {
      this.$emit("input", newValue);
    },
  },
};
</script>
